import theme from 'styles/themes/default';

type Props = {
  'data-test'?: string;
  className?: string;
};

function Arrow({ 'data-test': dataTest, ...props }: Props) {
  return (
    <svg
      data-test={dataTest}
      fill={theme.colors.gray.light}
      height="40"
      viewBox="0 0 16 16"
      width="50"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8.79123 14.7913L8.79123 3.62126L13.6712 8.50126C14.0612 8.89126 14.7012 8.89126 15.0912 8.50126C15.4812 8.11126 15.4812 7.48126 15.0912 7.09126L8.50123 0.501258C8.11123 0.111258 7.48123 0.111258 7.09123 0.501259L0.49123 7.08126C0.10123 7.47126 0.10123 8.10126 0.49123 8.49126C0.88123 8.88126 1.51123 8.88126 1.90123 8.49126L6.79123 3.62126L6.79123 14.7913C6.79123 15.3413 7.24123 15.7913 7.79123 15.7913C8.34123 15.7913 8.79123 15.3413 8.79123 14.7913Z" />
    </svg>
  );
}

export default Arrow;
